import {TopToolbar, useRedirect} from "react-admin";
import {Button} from "@material-ui/core";
import {Cancel} from "@material-ui/icons";

export const CancelToolbar = ({ basePath, data }) => {
  const redirect = useRedirect()
  return (
    <TopToolbar>
      <Button onClick={() => redirect(`${basePath}`)} startIcon={<Cancel />} children={'Cancelar'} />
    </TopToolbar>
  )
};
